export default "__VITE_ASSET__BpM9Juqe__"